import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Enums } from 'src/app/Shared/enums';
import { LoanService } from 'src/services/loan.service';

interface Report {
  DateCreated: Date,
  Outstanding: number,
  CustomerName: string,
  CustomerId: number,
  ReceiptNumber: string,
  Principal: number,
  RemainingTerm: number,
  Status: number
}

@Component({
    selector: 'app-loan-scheme-report',
    templateUrl: './loan-scheme-report.component.html',
    styleUrls: ['./loan-scheme-report.component.scss'],
    standalone: false
})
export class LoanSchemeReportComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private enums = inject(Enums);
  private loanService = inject(LoanService);

  displayedColumns: string[];
  dataSource = new MatTableDataSource;
  showRemark: string;

  @Input() selectedCompany: number;
  @Input() selectedReport: number;
  @Input() schemeName: string;

  reportList: Report[] = [];

  routeSubscription: any;

  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {

    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCompany = + params.get('companyId');
      this.selectedReport = + params.get('reportId');
      this.schemeName = params.get('scheme');

      this.getReport();

      if (this.schemeName == 'A')
        this.displayedColumns = ['DateCreated', 'ReceiptNumber', 'CustomerName', 'Principal', 'Outstanding', 'Status'];
      else
        this.displayedColumns = ['DateCreated', 'ReceiptNumber', 'CustomerName', 'Principal', 'Outstanding', 'RemainingTerm', 'Status'];


    });

  }

  refreshDataSource() {
    this.dataSource.data = this.reportList;
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  convertStatusString(loanStatus: number) {

    if (loanStatus == this.enums.ACTIVE_LOAN)
      return "ACTIVE"
    else if (loanStatus == this.enums.WARNING_LOAN)
      return "WARNING"
    else if (loanStatus == this.enums.SETTLED_LOAN)
      return "SETTLED"
    else if (loanStatus == this.enums.BAD_DEBT_LOAN)
      return "BAD DEBT"
    else
      return "CP";
  }

  getStatusColor(status: number) {

    let color: string;

    switch (status) {
      case this.enums.ACTIVE_CUST:
        color = "bg-primary";
        break;
      case this.enums.WARNING_CUST:
        color = "bg-warning";
        break;
      case this.enums.BAD_DEBT_CUST:
        color = "bg-dark";
        break;
      case this.enums.CP_CUST:
        color = "bg-info";
        break;
      default:
        color = "bg-success";
        break;
    }
    return color;
  }

  resetList() {
    this.reportList.splice(0, this.reportList.length);
  }


  calculateTotalPrincipal() {
    let sum = 0;
    for (let i = 0; i < this.reportList.length; i++)
      sum += this.reportList[i].Principal;

    return sum;
  }

  calculateTotalOutstanding() {
    let sum = 0;
    for (let i = 0; i < this.reportList.length; i++)
      sum += this.reportList[i].Outstanding;

    return sum;
  }

  goToCustomer(customerId: number) {
    this.router.navigate(['/manageCustomer', customerId]);
  }

  async getReport() {
    this.resetList();

    const schemes: string[] = [];
    // if (this.schemeName == 'P' && this.sharedService.isBranchAccountHandler())
    //   schemes = ['P', 'EPF'];
    // else
    schemes.push(this.schemeName);

    const l = await this.loanService.getCompanyLoans(this.selectedCompany, { schemes: schemes });
    l.reduce((result, loan) => {
      if (loan.Balance > 0) {
        result.push({
          DateCreated: loan.DateCreated,
          Outstanding: loan.Balance,
          CustomerId: loan.CustomerId,
          CustomerName: loan.CustomerName,
          ReceiptNumber: loan.ReceiptNumber,
          Principal: loan.Principal,
          RemainingTerm: loan.Balance / loan.MonthlyPayment,
          Status: loan.Status
        } as Report);
      }
      return result;
    }, this.reportList);

    //make customer list as the datasource
    this.dataSource = new MatTableDataSource<Report>(this.reportList);
    //  this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
